import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-twitter',
  templateUrl: './twitter.component.html',
  styleUrls: ['./twitter.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TwitterIconComponent {}
